import React from "react";
import Card from "components/card";
import { Users, Mail, MapPin } from "lucide-react";

const TeamCard = ({ 
    cte_name, 
    cte_status_name,
    cte_description,
    supervisor_initials,
    supervisor_email,
    supervisor_name,
    established_date,
    members_count,
    countries
}) => {

    return (
        <Card className="bg-white text-slate-900 gap-6 rounded-2xl border-2 border-slate-200 dark:border-zinc-700 hover:shadow-lg transition-shadow duration-300 h-full flex flex-col">
            <div className="grid auto-rows-min grid-rows-[auto_auto] items-start gap-1.5 px-6 pt-6">
                <div className="flex items-start justify-between">
                    <div className="flex-1">
                        <h4 className="text-lg label-gradient emerald">
                            {cte_name}
                        </h4>
                        <span className={`status-indicator ${cte_status_name?.toLowerCase().replace(/\s+/g, "-")}`}>
                            {cte_status_name}
                        </span>
                    </div>
                    <div className="w-12 h-12 rounded-full bg-gradient-to-br from-purple-500 to-green-500 flex items-center justify-center">
                        <Users className="w-6 h-6 text-white" />
                    </div>
                </div>
            </div>
            <div className="px-6 pb-6 space-y-4 flex-1 flex flex-col">
                <p className="text-[13px] text-slate-700 line-clamp-2">
                    {cte_description}
                </p>
                <div className="bg-slate-200 shrink-0 h-px w-full"></div>
                <div className="space-y-2">
                    <div className="flex items-center gap-2">
                        <div className="w-8 h-8 rounded-full bg-gradient-to-br from-blue-500 to-purple-500 flex items-center justify-center">
                            <span className="text-white text-xs">
                                {supervisor_initials}
                            </span>
                        </div>
                        <div className="flex-1 min-w-0">
                            <p className="text-[11px] text-slate-700">
                                Team Manager
                            </p>
                            <p className="text-[13px] truncate">
                                {supervisor_name}
                            </p>
                        </div>
                    </div>
                    <div className="flex items-center gap-2 text-[12px] text-slate-700">
                        <Mail className="w-3 h-3" />
                        <span className="truncate">{supervisor_email}</span>
                    </div>
                    <div className="bg-slate-200 shrink-0 h-px w-full"></div>
                    <div className="grid grid-cols-2 gap-3">
                        <div className="space-y-1">
                            <p className="text-[11px] text-slate-700 uppercase tracking-wide">
                                Members
                            </p>
                            <p className="text-lg">
                               {members_count}
                            </p>
                        </div>
                        <div className="space-y-1">
                            <p className="text-[11px] text-slate-700 uppercase tracking-wide">
                                Established
                            </p>
                            <p className="text-[13px] tracking-normal">
                               {established_date}
                            </p>
                        </div>
                    </div>
                    <div className="bg-slate-200 shrink-0 h-px w-full"></div>
                    <div className="flex items-start gap-2">
                        <MapPin className="w-4 h-4 text-slate-700 mt-0.5 flex-shrink-0" />
                        <div className="flex-1 min-w-0">
                            <p className="text-[11px] text-slate-700 uppercase tracking-wide">
                                Locations
                            </p>
                            <p className="text-[13px] text-slate-700 line-clamp-2 mt-0.5">
                                {countries}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </Card>
    );
};

export default TeamCard;